import { createFileRoute } from "@tanstack/react-router";

import { ResultsHighlights } from "~/components/feature/results/components";

export const Route = createFileRoute("/_app/dashboard/results/highlights")({
  component: RouteComponent,
});

function RouteComponent() {
  return <ResultsHighlights />;
}
